import * as React from 'react'
import DialogContent from '@mui/material/DialogContent'
import { BootstrapDialog, BootstrapDialogTitle } from 'common/AbstractModal/BootstrapDialog'

import { NewUserPlanForm } from '../sharedComponents/AddUserPlanForm'

interface UserPlanDialogProps {
  userPlanDialogOpen: boolean
  userId: string
  handleUserPlanDialogClose: () => void
}

export default function AddUserPlanDialog({
  userId,
  userPlanDialogOpen,
  handleUserPlanDialogClose
}: UserPlanDialogProps) {
  //handle form submit api here
  return (
    <div>
      <BootstrapDialog
        fullWidth
        maxWidth='lg'
        onClose={() => handleUserPlanDialogClose()}
        aria-labelledby='customized-dialog-title'
        open={userPlanDialogOpen}
      >
        <BootstrapDialogTitle onClose={() => handleUserPlanDialogClose()}>
          Add a new user plan
        </BootstrapDialogTitle>
        <DialogContent dividers sx={{ height: '60vh' }}>
          <NewUserPlanForm
            handleClose={handleUserPlanDialogClose}
            userId={userId}
          />
        </DialogContent>
      </BootstrapDialog>
    </div>
  )
}
